import { useState } from "react";
import { IoChevronBack } from "react-icons/io5";
import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import { useAppDispatch } from "../../../utils/hooks";
import Media from "./Media";
import Documents from "./Documents";
import Links from "./Links";
import TextTranslate from "../../../utils/TextTranslate";

const TABS = [
  { id: 0, label: "Media" },
  { id: 1, label: "Docs" },
  { id: 2, label: "Links" },
] as const;

export default function MediaLinksDocsTabs() {
  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useAppDispatch();

  return (
    <div className="flex h-full min-h-0 w-full flex-col bg-secondary">
      <div className="sticky top-0 z-20 shrink-0 border-b border-black/[0.06] bg-secondary/85 backdrop-blur-xl dark:border-white/[0.08]">
        <div className="flex items-center justify-between px-3 py-3">
          <button
            type="button"
            aria-label="Back"
            className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
            onClick={() => {
              dispatch(updateViewState({ showMediaDocLinks: false }));
            }}
          >
            <IoChevronBack className="text-xl" />
          </button>
          <span className="max-w-[14rem] truncate text-center text-[17px] font-semibold tracking-tight text-darkText">
            <TextTranslate text="Media, links and docs" />
          </span>
          <div className="h-9 w-9" aria-hidden />
        </div>

        {/* iOS segmented control */}
        <div className="px-4 pb-3">
          <div
            className="grid grid-cols-3 rounded-[9px] bg-black/[0.06] p-[3px] dark:bg-white/[0.1]"
            role="tablist"
          >
            {TABS.map((tab) => {
              const active = selectedTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={active}
                  onClick={() => setSelectedTab(tab.id)}
                  className={`rounded-[7px] py-1.5 text-center text-[13px] font-semibold transition ${
                    active
                      ? "bg-primary text-darkText shadow-sm"
                      : "text-darkText/55"
                  }`}
                >
                  <TextTranslate text={tab.label} />
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-3 py-3 pb-10">
        {selectedTab === 0 && <Media />}
        {selectedTab === 1 && <Documents />}
        {selectedTab === 2 && <Links />}
      </div>
    </div>
  );
}
